/** 全站 AI 客服（扣子经后端代理）是否已启用，由 CozeServiceBot 探测后写入 */
let serviceEnabled = false;

export function setCozeServiceEnabled(enabled) {
  serviceEnabled = !!enabled;
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("coze-service-enabled-change", { detail: serviceEnabled })
    );
  }
}

export function isCozeServiceEnabled() {
  return serviceEnabled;
}
